<template>
  <div>
    <div class="row col-md-12">
      <div class="card card-siak">
        <div class="d-flex justify-content-between align-items-center">
          <div class="title">
            <h1>Master Mess</h1>
          </div>
          <div class="toolbar">
            <ButtonComponent colors="#3751E4" name="tambah" v-b-modal.modal @click.native="openModal('Tambah')">
            </ButtonComponent>
          </div>
        </div>
        <KTCodePreview>
          <template v-slot:preview>
            <v-card>
              <v-card-title>
                <!-- $func.exportCsv to export csv -->
                <ButtonComponent colors="#17A1FA" name="csv" @click.native="$func.exportCsv">
                </ButtonComponent>
                <v-spacer></v-spacer>
                <v-text-field v-model="code4.search" label="Search" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="code4.headers" :items="code4.desserts" :search="code4.search">
                <template v-slot:item.no="{ item ,index }">
                  {{ item.no }}
                </template>
                <template v-slot:item.status="{ item }">
                  <b-badge v-if="item.status === true" class="mr-1" variant="primary">Aktif</b-badge>
                  <b-badge v-else class="mr-1" variant="danger">Tidak Aktif</b-badge>
                </template>
                <template v-slot:item.action="{ item }">
                  <ButtonComponent colors="#3751E4" name="edit" v-b-modal.modal @click.native="openModal('Edit')">
                  </ButtonComponent>
                  <ButtonComponent colors="#EF4848" name="hapus"></ButtonComponent>
                </template>
              </v-data-table>
            </v-card>
          </template>
        </KTCodePreview>
        <b-modal ok-title="Simpan" ok-variant="primary" cancel-title="Batal" cancel-variant="danger" id="modal"
          :title="`${statusModal} Mess`">
          <b-form>
            <b-form-group id="input-group-1" label="Nama Mess :" label-for="input-1">
              <b-form-input id="input-1" type="text" required placeholder="Masukkan Nama Mess"></b-form-input>
            </b-form-group>
          </b-form>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CodePreview.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue"

export default {
  data() {
    return {
      code4: {
        search: "",
        headers: [
          {
            text: "No",
            value: "no"
          },
          { text: "Nama Mess", value: "namaMess" },
          { text: "Aksi", value: "action" }
        ],
        desserts: [
          {
            no: 1,
            namaMess: "Mess Fatahilah",
          },
          {
            no: 2,
            namaMess: "Mess Malahayati",
          },
          {
            no: 3,
            namaMess: "Mess Nala",
          },
          {
            no: 4,
            namaMess: "Mess Bambang Susilo",
          },
          {
            no: 5,
            namaMess: "Mess Suparno",
          }
        ]
      },
      statusModal: ''
    };
  },
  components: {
    KTCodePreview,
    ButtonComponent
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Master" },
      { title: "Mess" }
    ]);

    // set csv export name and data
    this.$store.commit('updateCsvName', { name: 'Data Export Mess', data: this.code4.desserts })
  },
  methods: {
    openModal(status) {
      this.statusModal = status
    }
  }
}
</script>